import { put, call } from "redux-saga/effects";

import * as actions from "../actions";

import * as Api from "../../api";

export function* uploadDocumentation({ payload }) {
  try {
    const response = yield call(Api.uploadDocumentation, payload);
    if (response.status !== 200) {
      yield put(actions.addError("RightToWork", response));
      throw new Error(
        `Failed to process right to work request: ${response.status}`
      );
    }
  } catch (error) {
    yield put(actions.addError("Documentation", error));
    yield put(actions.documentationError(error));
  }
}

// not used, to be deleted (?)
export function* documentationSuccess() {
  try {
    // yield history.push("/profile");
  } catch (error) {
    yield put(actions.addError("Documentation", error));
  }
}
